import {css} from "styled-components"

import {ButtonCssProps} from "./index"

const primaryCss = css<ButtonCssProps>`
  ${({theme, inverted}) => css`
    border: none;
    background-color: ${theme.colors.primary1};
    color: ${theme.colors.utility.white};
    border: 2px solid ${theme.colors.primary1};

    path {
      fill: ${theme.colors.utility.white};
    }

    &:hover,
    &:focus,
    &:active {
      background-color: ${theme.colors.primary1_600};
      border: 2px solid ${theme.colors.primary1_600};
      text-decoration: none;
    }

    &:disabled,
    &.disabled {
      color: ${theme.colors.utility.white};
      background-color: ${theme.colors.primary1_100};
      border: 2px solid ${theme.colors.primary1_100};
      path {
        fill: ${theme.colors.utility.white};
      }
    }
    ${inverted &&
    `
      color: ${theme.colors.primary2};
      background-color: ${theme.colors.utility.white};
      border: 2px solid ${theme.colors.utility.white};
      path {
        fill: ${theme.colors.primary2};
      }
      &:hover, &:active, &:focus {
        background-color: ${theme.colors.primary2_50};
        border: 2px solid ${theme.colors.primary2_50};
      }
      &:disabled, &.disabled {
        color: ${theme.colors.primary2};
        border: 2px solid ${theme.colors.primary2_200};
        background-color: ${theme.colors.primary2_200};
        path {
          fill: ${theme.colors.primary2};
        }
      }
    `}
  `}
`

export default primaryCss
